module.exports = __webpack_public_path__ + "static/media/android.44f4e2a0.svg";